import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const addressForFinancialRecords = () => ({
    header : "Financial records location",
    text : [
        "Enter the address where records are kept for Nova Scotia clients."
    ],
    headerRenewal : "Financial records location",
    textRenewal : [
        "Review the address where records are kept for Nova Scotia clients."
    ],
    navigation : {
        next : ROUTE_PATH.CRIMINAL_HISTORY_QUESTION,
        nextRenewal : ROUTE_PATH.CRIMINAL_HISTORY_QUESTION
    },
    addressTextHeader : "Street address",
    cityTextHeader : "City/Town",
    postalCodeTextHeader : "Postal code",
    provinceTextHeader : "Province",
})

const addressForFinancialRecordsSlice = createSlice({
    name : "addressForFinancialRecords",
    initialState : addressForFinancialRecords(),
    reducers : {
        searchAddressStart(state, action) { 
            state.searchStatus = "in-progress"
        },
        searchAddressSuccess(state, action) { 
            state.searchStatus = "success"
        },
        searchAddressError(state, action) { 
            state.searchStatus = "error"
        }
    }
})

export const {
    searchAddressStart,
    searchAddressSuccess,
    searchAddressError
} = addressForFinancialRecordsSlice.actions

export default addressForFinancialRecordsSlice.reducer
